import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-toggle-switch-button',
    templateUrl: './toggle-switch-button.component.html',
    styleUrl: './toggle-switch-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToggleSwitchButtonComponent {

  @Input() isChecked: boolean = false;
  @Input() activeColor: string = '#007BFF';
  @Input() inactiveColor: string = '#ccc';
  @Input() size: 'pill-sm' | 'pill-md' | 'pill-lg' = 'pill-sm';

  @Output() onChecked = new EventEmitter<boolean>();

  toggle(): void {
    this.isChecked = !this.isChecked;
    this.onChecked.emit(this.isChecked);
  }

}
